import {
  MODAL_HIDDEN,
  MODAL_DATA_LOADED,
  MODAL_INTERACTION,
} from '../actions/constants';
import { RENAME_COLUMNS } from '../util/enums/EnumLayers';
import ModalRenameColumns from '../components/modals/ModalRenameColumns';

const INITIAL_STATE = {
  existing: [], // list of ColumnName
  names: [], // list of strings
  moreClicked: true,
  readyForSave: false,
};

function interaction(state, payload) {
  switch (payload.section) {
    case 'lhs': {
      return {
        ...state,
        existing: [...state.existing, payload.columnName],
        names: [...state.names, ''],
        moreClicked: false,
      };
    }
    case 'nameChanged': {
      return {
        ...state,
        names: [
          ...state.names.slice(0, payload.index),
          payload.newValue.replace(/[^A-Za-z0-9_]+/gi, '_'),
          ...state.names.slice(payload.index + 1),
        ],
      };
    }
    case 'remove': {
      return {
        ...state,
        existing: [
          ...state.existing.slice(0, payload.index),
          ...state.existing.slice(payload.index + 1),
        ],
        names: [
          ...state.names.slice(0, payload.index),
          ...state.names.slice(payload.index + 1),
        ],
      };
    }
    case 'moreClicked': {
      return { ...state, moreClicked: true };
    }
    default:
      return state;
  }
}

const modalRenameColumns = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MODAL_HIDDEN:
      return INITIAL_STATE; // reset modal
    case MODAL_DATA_LOADED:
      if (action.payload.modal === ModalRenameColumns) {
        if (action.payload.existingLayer) {
          // editing
          return {
            ...INITIAL_STATE,
            existing: action.payload.existingLayer.existing().map((c) => c),
            names: action.payload.existingLayer.names().map((n) => n),
            moreClicked: false,
            readyForSave: true,
          };
        }
        if (action.payload.relevantColumnName) {
          // new
          return {
            ...INITIAL_STATE,
            existing: [action.payload.relevantColumnName],
            names: [''],
            moreClicked: false,
          };
        }
      }
      return state;
    case MODAL_INTERACTION: {
      if (action.payload.modalType !== RENAME_COLUMNS) {
        return state;
      }
      const newState = interaction(state, action.payload.props);
      return {
        ...newState,
        readyForSave:
          newState.existing.length > 0 &&
          newState.names.findIndex((v) => v.length === 0) === -1,
      };
    }
    default:
      return state;
  }
};

export default modalRenameColumns;
